<div class="footer-menu" *ngIf="Device === DTypes.Desktop">
  <div class="pg-wrapper pt-2 pb-4">
    <div class="grid align-items-center justify-content-center">
      <ng-container *ngFor="let link of MenuFooter">
        <div class="col-auto footer-menu__link">
          <a routerLink="{{link.url}}" title="{{link.title}}">{{link.title}}</a>
        </div>
      </ng-container>
    </div>
  </div>
</div>

<div class="footer-menu" *ngIf="Device === DTypes.Mobile">
  <div class="footer-menu__mobile">
    <ng-container *ngFor="let link of MenuFooter">
      <div class="col-auto footer-menu__mobile-link">
        <a routerLinkActive="active" routerLink="{{link.url}}">{{link.title}}</a>
      </div>
    </ng-container>
  </div>
</div>
